<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
  >
    <span
      v-html="message"
      style="text-align: center;"
    ></span>
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      Zamknij
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    snackbar: false,
    message: 'To jest powiadomienie!',
    color: 'success',
    timeout: 5000
  }),
  methods: {
    showSnackbar(color, message, timeout = 5000) {
      this.snackbar = false;
      this.$nextTick(() => {
        this.color = color;
        this.message = message;
        this.snackbar = true;
        this.timeout = timeout;
      });
    },
    hideSnackbar() {
      this.snackbar = false;
    }
  },
  mounted() {
    this.$root.$on('showSnackbar', this.showSnackbar);
    this.$root.$on('hideSnackbar', this.hideSnackbar)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/Snackbar.vue